/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import AccordianFormLayout from "src/components/layouts/AccordianFormLayout/AccordianFormLayout";
import { useOutletContext } from "react-router-dom";
import { Chip } from "@mui/material";
import { handleValidNumber } from "src/utils/validations/numberInput";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useCountries from "src/hooks/useCountries";
import useCountryStates from "src/hooks/useCountryStates";
import useStateCities from "src/hooks/useStateCities";
import useInquiryLabels from "src/hooks/useInquiryLabels";

const CommunicationOption = [
  {
    label: "VISIT",
    value: "VISIT",
  },
  {
    label: "WHATSAPP",
    value: "WHATSAPP",
  },
  {
    label: "CALL",
    value: "CALL",
  },
  {
    label: "EMAIL",
    value: "EMAIL",
  },
  {
    label: "OTHER",
    value: "OTHER",
  },
];

const inquiryTypeOptions = [
  {
    label: "INBOUND",
    value: "INBOUND",
  },
  {
    label: "OUTBOUND",
    value: "OUTBOUND",
  },
  {
    label: "VISIT",
    value: "VISIT",
  }
];

const ContactInformation = () => {
  const [{ formikProps }]: any = useOutletContext();
  const { values, setFieldValue, isSubmitting, handleBlur, errors } = formikProps;
  const { countries, isDataLoading: isCountriesLoading } = useCountries();
  const { countryStates, isDataLoading: isCountryStatesLoading } =
    useCountryStates(values?.countryId?._id || "");
  const { stateCities, isDataLoading: isStateCitiesLoading } = useStateCities(
    values?.stateId?._id || ""
  );

  const { inquiryLabels, isDataLoading: inquiryLabelsLoading } =
  useInquiryLabels();


  const handleChipClick = (value: any) => {
    if (values?.inquired_for?.includes(value as any)) {
      let newIn = [...values.inquired_for];
      let updateIn = newIn.filter(
        (selectedValue: any) => selectedValue !== value
      );
      setFieldValue("inquired_for", [...updateIn]);
    } else {
      setFieldValue("inquired_for", [...values.inquired_for, value]);
    }
  };

   //Inquiry Label Option
   const InquiryLabelOptions = inquiryLabels?.map((el: any, ind: any) => {
    return {
      label: el?.inquiryLabel,
      value: el?._id,
    };
  });

  return (
    <div className="xl:mr-2 mr-0">
      <div className="border-l-[3px] border-primary-dark px-3 py-1 z-10 my-2 font font-medium text-[18px] sticky -top-3 bg-white  text-primary-dark">
        Information
      </div>
      <div className="my-1 font-semibold text-red-500">{errors?.any_one_contact && <div>Please enter any one filed among Mobile number , Email And Other Social Media Id's </div>}</div>
      <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
        {/* Mobile Number */}
        <div className="">
          <ATMTextField
            name="mobile"
            value={values.mobile}
            onChange={(e) =>
              handleValidNumber(e, { forMobile: true }) && setFieldValue("mobile", e.target.value)
            }
            label="Mobile Number"
            placeholder="Enter Mobile Number"
            onBlur={handleBlur}
          />
        </div>
        {/* Name */}
        <div>
          <ATMTextField
            name="name"
            value={values.name}
            onChange={(e) => setFieldValue("name", e.target.value)}
            label="Name"
            placeholder="Enter Name"
            onBlur={handleBlur}
          />
        </div>

        {/* Email */}
        <div className="">
          <ATMTextField
            name="email"
            value={values.email}
            onChange={(e) => setFieldValue("email", e.target.value)}
            label="Email"
            placeholder="Enter Email"
            onBlur={handleBlur}
          />
        </div>
        {/*WhatsApp Mobile Number */}
        <div >
          <ATMTextField
            name="whatsApp_mobile"
            value={values.whatsApp_mobile}
            onChange={(e) => handleValidNumber(e, { forMobile: true }) && setFieldValue("whatsApp_mobile", e.target.value)}
            label="WhatsApp Number"
            placeholder="Enter WhatsApp Number"
            onBlur={handleBlur}
          />
        </div>
        {/*Alternate Number 1 */}
        <div>
          <ATMTextField
            name="alternate_number_1"
            value={values.alternate_number_1}
            onChange={(e) => handleValidNumber(e, { forMobile: true }) && setFieldValue("alternate_number_1", e.target.value)}
            label="Alternate Number 1"
            placeholder="Enter Alternate Number 1"
            onBlur={handleBlur}
          />
        </div>
        {/*Alternate Number 2 */}
        <div >
          <ATMTextField
            name="alternate_number_2"
            value={values.alternate_number_2}
            onChange={(e) => handleValidNumber(e, { forMobile: true }) && setFieldValue("alternate_number_2", e.target.value)}
            label="Alternate Number 2"
            placeholder="Enter Alternate Number"
            onBlur={handleBlur}
          />
        </div>
        {/* Inquiry Type */}
        <div className="">
          <ATMSelect
            name="inquiryType"
            value={values?.inquiryType}
            onChange={(value) => setFieldValue("inquiryType", value)}
            options={inquiryTypeOptions}
            label="Inquiry Type"
          />
        </div>
          {/* Inquiry Label */}
          <div className="">
          <ATMSelect
            name="inquiryLabel"
            value={values?.inquiryLabel}
            onChange={(value) => setFieldValue("inquiryLabel", value)}
            options={InquiryLabelOptions}
            label="Inquiry Label"
            isLoading={inquiryLabelsLoading}
          />
        </div>

        {/* Country */}
        <div className="">
          <ATMSelect
            name="countryId"
            value={values.countryId}
            onChange={(newValue) => {
              setFieldValue("countryId", newValue);
              setFieldValue("stateId", "");
              setFieldValue("cityId", "");
            }}
            label="Country"
            placeholder="Select Country"
            options={countries}
            isLoading={isCountriesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return (
                  <div className="capitalize"> {option?.countryName} </div>
                );
              } else {
                return (
                  <div className="capitalize"> {option?.countryName} </div>
                );
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?._id === selected._id;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.countryName?.includes(searchValue)
                : true;
            }}
          />
        </div>

        {/* State */}
        <div className="">
          <ATMSelect
            name="stateId"
            value={values.stateId}
            onChange={(newValue) => {
              setFieldValue("stateId", newValue);
              setFieldValue("cityId", "");
            }}
            label="State"
            placeholder="Select State"
            options={countryStates}
            isLoading={isCountryStatesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.stateName} </div>;
              } else {
                return <div className="capitalize"> {option?.stateName} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?._id === selected._id;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.stateName?.includes(searchValue)
                : true;
            }}

          />
        </div>

        {/* City */}
        <div className="">
          <ATMSelect
            name="cityId"
            value={values.cityId}
            onChange={(newValue) => {
              setFieldValue("cityId", newValue);
            }}
            label="City"
            placeholder="Select City"
            options={stateCities}
            isLoading={isStateCitiesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.cityName} </div>;
              } else {
                return <div className="capitalize"> {option?.cityName} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?._id === selected._id;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.cityName?.includes(searchValue)
                : true;
            }}
          />
        </div>

      </div>
      <div className="mt-5">
        <AccordianFormLayout formHeading="OTHER" isOpen={true}>
          <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 p-2">
            {/* Linkedin ID */}
            <div className="">
              <ATMTextField
                name="linkedin_id"
                value={values?.linkedin_id}
                onChange={(e) => setFieldValue("linkedin_id", e.target.value)}
                label="Linkedin ID"
                placeholder="Enter Linkedin ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Twitter ID */}
            <div className="">
              <ATMTextField
                name="twitter_id"
                value={values?.twitter_id}
                onChange={(e) => setFieldValue("twitter_id", e.target.value)}
                label="Twitter ID"
                placeholder="Enter Twitter ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Instagram ID */}
            <div>
              <ATMTextField
                name="instagram_id"
                value={values.instagram_id}
                onChange={(e) => setFieldValue("instagram_id", e.target.value)}
                label="Instagram ID"
                placeholder="Enter Instagram ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Facebook ID */}
            <div className="">
              <ATMTextField
                name="facebook_id"
                value={values.facebook_id}
                onChange={(e) => setFieldValue("facebook_id", e.target.value)}
                label="Facebook ID"
                placeholder="Enter Facebook ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Youtube ID */}
            <div className="">
              <ATMTextField
                name="youtube_id"
                value={values.youtube_id}
                onChange={(e) => setFieldValue("youtube_id", e.target.value)}
                label="Youtube ID"
                placeholder="Enter Youtube ID"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </AccordianFormLayout>
      </div>
      <div className="mt-3">
        <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Communication :
        </div>
        <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 mt-2 xl:gap-6 md:gap-4">
          <ATMSelectValue
            name="communication_type"
            value={values?.communication_type}
            onChange={(value) => setFieldValue("communication_type", value)}
            options={CommunicationOption}
            label="Communication Type"
          />
          {/* Communication Remark */}
          <div className="">
            <ATMTextField
              name="communication_remark"
              value={values.communication_remark}
              onChange={(e) =>
                setFieldValue("communication_remark", e.target.value)
              }
              label="Communication Remark"
              placeholder="Enter Communication Remark"
              onBlur={handleBlur}
            />
          </div>
        </div>
        <div className="mt-4">
          <ATMTextArea
            name={`communication_summary`}
            value={values?.communication_summary}
            onChange={(e) => setFieldValue(`communication_summary`, e)}
            label="Communication Summary"
            placeholder="Enter Communication Summary"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div className="mt-6">
        <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px] sticky top-0 bg-white  text-primary-dark">
          Preferred Mode
        </div>
        <div className="grid xl:grid-cols-9 md:grid-cols-4 grid-cols-1 mt-3 gap-6">
          <Chip
            className="text-[16px]"
            color={`${values.inquired_for.includes("ONLINE") ? "primary" : "default"
              }`}
            label="Online"
            onClick={() => {

              handleChipClick("ONLINE");
            }}
          />
          <Chip
            className="text-[16px]"
            color={`${values.inquired_for.includes("CLASSROOM") ? "primary" : "default"
              }`}
            label="Classroom"
            onClick={() => {

              handleChipClick("CLASSROOM");
            }}
          />
          <Chip
            className="text-[16px]"
            color={`${values.inquired_for.includes("RECORDED") ? "primary" : "default"
              }`}
            label="Recorded"
            onClick={() => {
              handleChipClick("RECORDED");
            }}
          />
        </div>
      </div>
      <div className="flex justify-end mt-2">
        <ATMLoadingButton
          className="flex justify-end w-[90px] px-8"
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default ContactInformation;
